var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 17.1667C21.5667 17.1667 19.8333 16.9 18.3667 16.3667C18.2333 16.3667 18.1 16.3667 17.9667 16.3667C17.5667 16.3667 17.3 16.5 17.0333 16.7667L14.1 19.7C10.3667 17.7 7.16667 14.6333 5.3 10.9L8.23333 7.96667C8.63333 7.56667 8.76667 7.03333 8.5 6.63333C8.1 5.16667 7.83333 3.43333 7.83333 1.83333C7.83333 1.16667 7.16667 0.5 6.5 0.5H1.83333C1.16667 0.5 0.5 1.16667 0.5 1.83333C0.5 14.3667 10.6333 24.5 23.1667 24.5C23.8333 24.5 24.5 23.8333 24.5 23.1667V18.5C24.5 17.8333 23.8333 17.1667 23.1667 17.1667ZM3.16667 3.16667H5.16667C5.3 4.36667 5.56667 5.56667 5.83333 6.63333L4.23333 8.23333C3.7 6.63333 3.3 4.9 3.16667 3.16667ZM21.8333 21.8333C20.1 21.7 18.3667 21.3 16.7667 20.7667L18.3667 19.1667C19.4333 19.4333 20.6333 19.7 21.8333 19.7V21.8333Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d9b08a4fa2f5cbb0cd67c6778272c0f9.svg";
export { ForwardRef as ReactComponent };